var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _rect, _path10, _rect2, _rect3, _path11, _path12, _circle, _circle2, _path13;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgApplication = function SvgApplication(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 199,
    height: 110,
    fill: "none",
    viewBox: "0 0 199 110"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M16.32 94.355c-1.309.88-2.94 1.397-4.709 1.387-4.24-.039-7.64-3.146-7.61-6.927.038-3.459 2.93-6.292 6.662-6.722l5.657 12.262Zm-1.612-2.237a5.041 5.041 0 0 1-3.302 1.143c-2.658-.03-4.787-2.003-4.768-4.407.02-2.335 2.062-4.22 4.612-4.308",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#002A3A",
    strokeWidth: 1.446,
    d: "M14.708 92.118a5.041 5.041 0 0 1-3.302 1.143c-2.658-.03-4.787-2.003-4.768-4.407.02-2.335 2.062-4.22 4.612-4.308m5.07 9.809c-1.309.88-2.94 1.397-4.709 1.387-4.24-.039-7.64-3.146-7.61-6.927.038-3.459 2.93-6.292 6.662-6.722l5.657 12.262Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    stroke: "#002A3A",
    strokeWidth: 1.446,
    d: "M10.86 78.37c0 14.13 11.454 25.584 25.584 25.584 14.13 0 25.584-11.454 25.584-25.584H10.86Z",
    clipRule: "evenodd"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#0DD149",
    fillRule: "evenodd",
    d: "M28.595 86.136c0-.567-.465-1.032-1.032-1.032h-5.546c-.567 0-1.033.465-1.033 1.032v7.146c0 .567.466 1.033 1.033 1.033h5.546c.567 0 1.032-.466 1.032-1.033v-7.146Z",
    clipRule: "evenodd"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    stroke: "#002A3A",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.446,
    d: "M24.648 78.202v8.254"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#002A3A",
    d: "M62.355 99.806 79.291 26.63a9.424 9.424 0 0 1 9.181-7.299h87.07c7.064 0 12.295 6.567 10.716 13.452l-15.372 67.023H62.356Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m69.738 99.067 15.836-67.764a7.853 7.853 0 0 1 7.647-6.066h77.866c4.047 0 7.038 3.77 6.118 7.712l-15.451 66.118H69.738Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#002A3A",
    d: "M171.314 97.7H27.672a7.277 7.277 0 0 0 7.276 7.276h129.089a7.277 7.277 0 0 0 7.277-7.277Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#002A3A",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.858,
    d: "M121.985 1.188c2.304 0 4.171 2.315 4.171 5.171v44.267c0 2.856-1.867 5.171-4.171 5.171H59.17c-2.303 0-4.171-2.315-4.171-5.17V6.358c0-2.856 1.867-5.17 4.171-5.17h62.815Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 19.603,
    height: 18.203,
    x: 80.715,
    y: 6.792,
    fill: "#002A3A",
    rx: 3.52
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M93.155 10.607a3.746 3.746 0 0 1 0 5.262 3.66 3.66 0 0 1-5.212 0 3.746 3.746 0 0 1 0-5.262 3.66 3.66 0 0 1 5.212 0M97.584 23.383c-.23-1.068-.588-2.026-1.045-2.807-.773-1.322-1.784-2.057-2.84-2.057h-6.298c-1.055 0-2.066.735-2.84 2.057-.458.781-.814 1.74-1.045 2.807"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 46.335,
    height: 8.274,
    x: 67.348,
    y: 29.32,
    fill: "#fff",
    stroke: "#002A3A",
    strokeWidth: 1.76,
    rx: 4.137
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 46.335,
    height: 8.274,
    x: 67.348,
    y: 40.904,
    fill: "#00AFFF",
    rx: 4.137
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    stroke: "#002A3A",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.571,
    d: "M188.859 104.974H1.331"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    stroke: "#002A3A",
    strokeLinecap: "round",
    strokeWidth: 1.571,
    d: "M35.633 50.29c1.656.683 4.868 2.93 4.468 6.452-.5 4.402-4.335 5.452-4.835 9.853-.4 3.521 1.889 5.169 3.084 5.552M32.11 73.45c-1.012-.325-2.95-2.752-2.612-5.733.285-2.504 1.843-3.727 2.964-5.39"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 169.269,
    cy: 79.347,
    r: 24.418,
    fill: "#002A3A",
    transform: "rotate(14.416 169.269 79.347)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 164.793,
    cy: 79.353,
    r: 24.418,
    fill: "#0DD149",
    transform: "rotate(14.416 164.793 79.353)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m157.035 79.108-4.593 3.107a.835.835 0 0 1-1.291-.549l-.912-5.247a.835.835 0 0 1 1.137-.917l.924.375c.464-2.04 2.97-6.026 9.28-7.532 4.407-1.052 7.863.437 10.021 2.126.664.519.078 1.338-.737 1.124-7.764-2.033-13.049 2.74-14.852 5.694l.869.353a.835.835 0 0 1 .154 1.466ZM172.473 80.527l4.892-3.143a.835.835 0 0 1 1.273.552l.972 5.31a.835.835 0 0 1-1.122.93l-1.051-.405c-.488 2.04-3.126 6.026-9.768 7.533-4.664 1.057-8.317-.454-10.586-2.154-.676-.506-.111-1.332.708-1.124 8.23 2.101 13.833-2.7 15.739-5.667l-.906-.35a.836.836 0 0 1-.151-1.482Z"
  })));
};
export default SvgApplication;